import styled from 'styled-components';
import TextInput from '@/se/components/inputs/TextInput';
import responsive from '@/se/utilities/responsive';
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { updatePortSwitch } from '../../../graph/gateways';

const InlineTextInput = styled(TextInput)`
  outline: none;
  width: 4.5em;
  ${props => (props.disabled ? 'pointer-events: none' : undefined)};

  ${responsive.xs.andSmaller`
    width: 100%;
  `};
`;

class PortSwitchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: props.portSwitch };
  }

  onChange = mutation => value => {
    this.setState({ value });

    const { portSwitch, gateway } = this.props;
    if (portSwitch !== value) {
      mutation({ variables: { id: gateway, portSwitch: value } });
    }
  };
  render() {
    return (
      <Mutation mutation={updatePortSwitch}>
        {editGateway => (
          <InlineTextInput
            disabled={this.props.disabled}
            value={this.state.value}
            onChange={this.onChange(editGateway)}
          />
        )}
      </Mutation>
    );
  }
}

export default PortSwitchInput;
